module.exports = __webpack_public_path__ + "img/4.a84cd533.png";